// Copyright (c) 2024–2026 FieldIDX Inc. All rights reserved.
// Proprietary and confidential. Unauthorized use prohibited.
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";

// Sentry initialization for FieldIdx
Sentry.init({
  dsn: "https://db42b69b22854b7274520a41aa4391fe@o4510620399108096.ingest.us.sentry.io/4510621051846656",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  environment: import.meta.env.MODE,
  sendDefaultPii: true,
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

createRoot(document.getElementById("root")!).render(<App />);
